// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scheduler-header {
  height: 65px;
  border-bottom: 1px solid var(--gray-20);
}
.scheduler-column-left,
.scheduler-column-right {
  width: 280px;
}
.scheduler-column-left,
.scheduler-column-right {
  background-color: var(--gray-4);
}
.scheduler-column-center {
  flex: 1 1 auto;
  flex-grow: 1;
  background-color: var(--primary-white);
  border-left: 1px solid var(--gray-20);
  border-right: 1px solid var(--gray-20);
}
`, "",{"version":3,"sources":["webpack://./src/app/SUMOCEP/components/scheduler/scheduler.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,uCAAuC;AACzC;AACA;;EAEE,YAAY;AACd;AACA;;EAEE,+BAA+B;AACjC;AACA;EACE,cAAc;EACd,YAAY;EACZ,sCAAsC;EACtC,qCAAqC;EACrC,sCAAsC;AACxC","sourcesContent":[".scheduler-header {\n  height: 65px;\n  border-bottom: 1px solid var(--gray-20);\n}\n.scheduler-column-left,\n.scheduler-column-right {\n  width: 280px;\n}\n.scheduler-column-left,\n.scheduler-column-right {\n  background-color: var(--gray-4);\n}\n.scheduler-column-center {\n  flex: 1 1 auto;\n  flex-grow: 1;\n  background-color: var(--primary-white);\n  border-left: 1px solid var(--gray-20);\n  border-right: 1px solid var(--gray-20);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
